import { Accordion, AccordionDetails, AccordionSummary, useMediaQuery } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FC, ReactNode, useId, useState } from "react";
import styles from "@/components/appointmentDashboard/appointmentContextAccordion.module.css";

interface Props {
  title: string;
  expanded: boolean;
  onChange: (expanded: boolean) => void;
  children: ReactNode;
}

const AppointmentContextAccordion: FC<Props> = ({ title, expanded, onChange, children }) => {
  const id = useId();
  const [hasExited, setHasExited] = useState(!expanded);
  const reducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)");

  return (
    <Accordion
      className={styles.accordion}
      expanded={expanded}
      onChange={(_, nextExpanded) => onChange(nextExpanded)}
      disableGutters
      elevation={0}
      TransitionProps={{
        unmountOnExit: false,
        timeout: reducedMotion ? 0 : 220,
        onEnter: () => setHasExited(false),
        onExit: () => setHasExited(false),
        onExited: () => setHasExited(true),
      }}
    >
      <AccordionSummary
        className={styles.summary}
        id={`${id}-header`}
        aria-controls={`${id}-content`}
        expandIcon={<ExpandMoreIcon />}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails
        className={styles.details}
        hidden={!expanded && hasExited}
        aria-hidden={!expanded}
        {...(!expanded ? { inert: "" } : {})}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default AppointmentContextAccordion;
